import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RouterStateService } from 'src/app/root/router-state.service';
import { SettlementStatementSummary } from 'src/app/types';
import { STATEMENT_ID } from '../settlement-statement-routing.constants';
import { StatementService } from '../statement.service';

@Component({
  selector: 'lohi-settlement-printable',
  templateUrl: './settlement-printable.component.html',
  styles: [``],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettlementPrintableComponent implements OnInit {
  public summary$$: Observable<SettlementStatementSummary>;

  constructor(private routerState: RouterStateService, private statementService: StatementService) {
    this.summary$$ = combineLatest([
      this.routerState.listenForParamChange$(STATEMENT_ID),
      this.statementService.summaries$,
    ]).pipe(
      map(([id, summaries]) => {
        return (summaries?.statements || []).find((sum) => sum.id === +id);
      }),
    );
  }

  public ngOnInit(): void {}
}
